import {
    getCarousel
} from '../../../core/js/components/carouselComponent';

import template from 'contentful/render-modules.j2';

import multipleRRTemplate from 'multipleRRProductTrays.j2';
import productGridRecTray from '@core/templates/contentful/product-grid/product-grid-rec-tray.j2';
import textOverImageTemplate from '@core/templates/contentful/text-over-image-component.j2';

import { generate } from '../../../core/js/utils/componentUtils';

import { init as rrInit, determineRRPlacement } from '../../../core/js/components/richRelevanceComponent';
import { init as dyInit } from '../../../core/js/components/dynamicYieldRecommendationComponent';
import { default as accordionSupport } from '../../../core/js/uiSupport/accordion';
import { getDefaultOptions } from '../../../core/js/utils/a15componentUtils';
import {
    isUsingBackgroundColor,
    getHeightOfIntersectingTOIS
} from '@core/js/utils/backgroundColorTextOverImageUtils';

function findRRPlacementIds(store, feature) {
    const state = store.getState();
    const landing = _.get(state, `${feature}.landingPage`, _.get(state, `${feature}.content`));
    const landingModules = _.get(landing, 'fields.modules', []);
    const landingComponents = landingModules.reduce((components, module) => {
        return components.concat(_.get(module, 'fields.components', []));
    }, []);
    const dyLandingSlotEntries = _.filter(landingModules, (module) => {
        return !_.isEmpty(_.get(module, 'fields.recommendationPlacementId'));
    });
    const dyLandingSlotPlacementIds = _.map(dyLandingSlotEntries, 'fields.recommendationPlacementId');
    const dyModulePlacementIds = landingModules.reduce((ids, module) => {
        let seeMoreData = null;
        if (_.get(module, 'fields.source') === 'Dynamic Yield') {
            const seeMoreLink = _.get(module, 'fields.seeMoreLink.fields');
            if (seeMoreLink) {
                seeMoreData = {
                    seeMoreTitle: _.get(seeMoreLink, 'linkTitle'),
                    seeMoreUrl: _.get(seeMoreLink, 'linkPath')
                };
            }
            ids.push({
                componentValue: _.get(module, 'fields.value[0]'),
                componentSeeMore: seeMoreData,
                componentEntry: module,
            });
        }
        return ids;
    }, []);
    const dyComponentPlacementIds = landingComponents.reduce((ids, component) => {
        if (_.get(component, 'fields.source') === 'Dynamic Yield') {
            ids.push({
                componentValue: _.get(component, 'fields.value[0]'),
                componentEntry: component,
                componentType: _.get(component, 'sys.contentType.sys.id'),
                componentDisplayType: _.get(component, 'fields.displayType')
            });
        }
        return ids;
    }, []);

    const placementIds = [
        ...dyLandingSlotPlacementIds,
        ...dyComponentPlacementIds,
        ...dyModulePlacementIds
    ];

    return placementIds;
}

function generateDictionary(state, dict, config) {
    const recTray = _.get(state, `core.rrRecs.${this.rrPlacement}`);
    const displayType = _.get(config, 'displayType');
    const seeMoreOverride = _.get(config, 'seeMore');
    const entry = _.get(config, 'entry');
    const entryCtaLinks = _.get(entry, 'fields.ctaLinks');
    const entryTitle = _.get(entry, 'fields.title');

    if (seeMoreOverride) {
        recTray.seeMoreUrl = seeMoreOverride.seeMoreUrl;
        recTray.seeMoreTitle = seeMoreOverride.seeMoreTitle;
    }

    if (entry && !entryTitle && recTray.strategyName) {
        const recTitle = {
            title: `dy_${recTray.strategyName}`
        };
        entry.fields = Object.assign(entry.fields, recTitle);
    }

    if (entry && !entryCtaLinks && recTray.seeMoreUrl) {
        const recCtaLinks = {
            ctaLinks: [{
                fields: {
                    linkPath: recTray.seeMoreUrl
                }
            }]
        };
        entry.fields = Object.assign(entry.fields, recCtaLinks);
    }

    const data = {
        rrData: recTray,
        displayType: displayType,
        entry: entry
    };

    const result = Object.assign({}, dict, data);

    return result;
}

function getTemplateType(componentData) {
    let templateType = multipleRRTemplate;

    if (componentData.type === 'componentProductGrid') {
        templateType = productGridRecTray;
    } else if(componentData.type === 'textOverImageComponent') {
        templateType = textOverImageTemplate;
    }

    return templateType;
}

function makeRRTray(store, rrRecsKey, componentData) {
    const rrTray = [rrInit, {
        rrPlacement: rrRecsKey,
        name: `landingPage_${rrRecsKey}_trayComponent`,
        templateLocation: `.dom-rr-${rrRecsKey} .dom-rr-container`,
        watch: `core.rrRecs.${rrRecsKey}`,
        template: getTemplateType(componentData),
        generateDictionary: generateDictionary,
        children: [
            [dyInit, {
                beforeConstruction: determineRRPlacement
            }]
        ],
        displayType: componentData.displayType,
        seeMore: componentData.seeMore,
        entry: componentData.entry
    }];

    return rrTray;
}

function getChildren(store, feature) {
    const rrPlacementIds = findRRPlacementIds(store, feature);

    return _.map(rrPlacementIds, (placementId) => {
        const value = _.get(placementId, 'componentValue');
        const id = value ? value : placementId;
        const placementKey = _.replace(id, '.', '__');
        const componentData = {
            entry: _.get(placementId, 'componentEntry'),
            type: _.get(placementId, 'componentType'),
            displayType: _.get(placementId, 'componentDisplayType'),
            seeMore: _.get(placementId, 'componentSeeMore')
        };

        return makeRRTray(store, placementKey, componentData);
    });
}

export function attachEvents(store) {
    $(document).ready(() => {
        let tois = {
            backgroundColorTOIS: [],
            observer: null
        };

        const options = {
            threshold: 0.25,
            rootMargin: '145px 0px 0px 0px',
            root: document.querySelector('.js-site-wrap')
        }

        if (!tois.observer) {
            tois.observer = new IntersectionObserver(getHeightOfIntersectingTOIS, options);
        }

        if (!tois.backgroundColorTOIS.length) {
            tois.backgroundColorTOIS = [...document.querySelectorAll('.js-toi')];
            const dyTOIS = [...document.querySelectorAll('.c-contentful-module__textOverImageComponent .dom-rr-pdp, .c-contentful-module__textOverImageComponent .dom-rr-recentlyViewed')];
            tois.backgroundColorTOIS = tois.backgroundColorTOIS.concat(...dyTOIS);
            tois.backgroundColorTOIS = tois.backgroundColorTOIS.reduce((bgTOIS, toi) => {
                if (isUsingBackgroundColor(toi)) {
                    bgTOIS.push(toi);
                }
                return bgTOIS;
            }, []);
        }
        tois.backgroundColorTOIS.forEach((toi) => tois.observer.observe(toi));

        $(window).on('resize', _.debounce(() => {
            const { backgroundColorTOIS, observer } = tois;
            backgroundColorTOIS.forEach((toi) => {
                observer.unobserve(toi);
                observer.observe(toi);
            });
        }, 0));
    });
}

export function afterConstruction(store) {
    accordionSupport(this, this.templateLocation);
}

export function init(store, overrides = {}) {
    const feature = overrides.feature ? overrides.feature : 'category';
    const config = {
        completionCallback: () => getCarousel(),
        templateLocation: '.dom-category-modules',
        template: template,
        watch: 'category.landingPage',
        name: 'categoryLandingSlotsComponent',
        children: getChildren(store, feature),
        feature: feature,
        afterConstruction: afterConstruction,
        attachEvents: attachEvents
    };

    return generate(config, store, overrides, getDefaultOptions(store));
}
